import { UseFormSetValue } from "react-hook-form"

/** profile* fieldName prefix (e.g. profilePhone, profileWhatsappOptIn). */
const applyPhoneWhatsappOptInSideEffects = (
  fieldName: string,
  enabled: boolean,
  setValue: UseFormSetValue<any>,
) => {
  if (fieldName === "profileWhatsappOptIn" && enabled) {
    setValue("profilePhoneEnabled", true, { shouldDirty: true })
  }
  if (fieldName === "profilePhone" && !enabled) {
    setValue("profileWhatsappOptInEnabled", false, { shouldDirty: true })
  }
}

export default applyPhoneWhatsappOptInSideEffects
